<template>
  <router-view/>
</template>

<style lang="scss">
#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    height: 100vh;
}

body {
  margin: 0;
}

.icon-button {
    cursor: pointer;
    display: flex;
    column-gap: 8px;
    align-items: center;
    padding: 8px;
    box-sizing: border-box;

    &:hover {
        opacity: 0.5;
    }
}

* {
    font-family: Avenir, Helvetica, Arial, sans-serif;
}

.el-divider *{
    font-weight: bold;
}

.uppercase, .uppercase input {
    text-transform: uppercase;
}
</style>
<script setup lang="ts">
</script>